import React from 'react'
import ArchivedOrderContent from '../components/ArchivedOrder/ArchivedOrderContent'
import ArchivedOrderProvider from '../context/ArchivedOrderContext'

const ArchivedOrder = () => {
  return (
    <ArchivedOrderProvider>
      <ArchivedOrderContent />
    </ArchivedOrderProvider>
  )
}

export default ArchivedOrder
